<template>
  <!-- 流程跟踪 -->
  <div class="bg-FF p-20">
    <div v-for="(item, index) in taskTracks" :key="index" class="p-10">
      <div class="flex col-center">
        <img class="w-46 h-46"
             :src="getOpinionIcon(item.optionVOList,getTrackTimeStamp(item,index,data),index,data,item)"/>
        <div class="flex-1 font-30 cor-33 font-weight-600 m-l-24">{{ item.name }}</div>
        <div class="font-28 cor-99 white-spc-nowrap">
          {{ item.endTime == null ? '' : moment(item.endTime).format('YYYY-MM-DD') }}
        </div>
      </div>
      <div v-if="item.assigneeName" class="flex p-t-20 p-l-70  p-r-30 rela"
           :class="index + 1 != taskTracks.length ? 'border-left' :''">
        <img class="w-24 h-28 " :src="`${image_base_url}/ren.png`"/>
        <div class="font-28 cor-F8BD29 font-weight-500 m-l-10 ">
          {{ item.assigneeName == null ? '' : item.assigneeName }}
        </div>
      </div>
      <div v-if="(item.assigneeNames && item.assigneeNames.length>0) || item.isCs"
           class="flex p-t-20 p-l-70  p-r-30 rela" :class="index + 1 != data.length? 'border-left' :''"
           v-for="(csuser, index) in item.assigneeNames">
        <img class="w-24 h-28 " :src="`${image_base_url}/ren.png`"/>
        <div class="font-28 cor-F8BD29 font-weight-500 m-l-10 ">{{ csuser.userName }}</div>
        <span class="font-28">（</span>
        <div v-if="csuser.readFlag" :style="{ color: csuser.readTime ? '#47bc82' : '#f25643' }" class="font-28">
          {{ csuser.readFlag }}
        </div>
        <span class="font-28"> ）</span>
      </div>
      <div v-if="item.optionVOList && item.optionVOList.length>0" class="flex p-l-70 p-b-20 p-r-30 rela"
           :class="index + 1 != data.length? 'border-left' :''" v-for="(option, index) in item.optionVOList">
        <div class="p-t-10 font-32   font-weight-500 m-l-10">
          <div v-if="option.userName">
            <i style="color: #FFB751" class="el-icon-user-solid font-16"></i>
            <span class="cor-F8BD29">
              {{ option.userName }}
            </span>
          </div>
          <div class="opinionContent font-32" v-if="option.createTime">
            {{ getOpinion(option) }}
          </div>
        </div>
      </div>
      <div class="flex p-l-70 p-b-20 p-r-30 rela" v-if="item.attachmentVOList">
        <img v-for="(img,i) in item.attachmentVOList" @click="previewImg(item.attachmentVOList,i)" :key="i"
             :src="img.url" :class="{'m-l-16':i !== 0}" class="w-150 h-150"></img>
      </div>
      <div v-if="item.signImage" style="display: flex;color: rgb(168, 173, 175);padding-top:5px;vertical-align: top">
        <div>签名：</div>
        <img :src="item.signImage" width="160px" height="90px"/></div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getProject} from '@/api/project/project'
import moment from "moment";

export default {
  props: {
    flowTraceList: {
      type: Array,
      default: []
    },
    processInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    flowTraceList() {
      this.buildFlowTraceList();
    },
    processInfo() {
      this.buildProcessInfo();
    }
  },
  data() {
    const _this = this;
    return {
      moment,
      data: [],
      currentNode: {},
      activities: [],
      cc: [],
      startUser: {},
      conditionFormItem: new Set(),
      formData: {},
      process: {},
      taskTracks: [],
      processUsers: {},
      select: [],
      selectedNode: {},
      selfSelect: false,
      runningList: [],
      endList: [],
      nodeUsers: {},
      // 项目负责人
      projectLeader: {},
      actCurrentNode: this.processInfo.actCurrentNode,
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    })
  },
  methods: {
    previewImg(imgList, i) {
      this.$imagePreview({
        images: imgList.map(item => item.url),
        startPosition: i,
      })
    },
    async buildProcessInfo() {
      if (!this.processInfo) return;
      this.formData = this.processInfo.formData
      this.currentNode = this.processInfo.currentNode
      this.startUser = this.processInfo.startUser
      if (this.processInfo.hisProcess) {
        this.process = JSON.parse(this.processInfo.hisProcess)
      }
      this.taskTracks = this.processInfo.taskTrackList
      this.runningList = this.processInfo.runningList
      this.endList = this.processInfo.endList
      this.nodeUsers = this.processInfo.nodeUsers
      if (this.formData && this.formData.ssxm) {
        let ssxms = this.formData.ssxm.split(',');
        if (isNaN(parseFloat(ssxms[0]))) {
          console.error(ssxms, '该值不是数字,停止执行后续逻辑')
          // return
        }
        console.log(this.projectLeader.projectId)
        if (ssxms[0] != this.projectLeader.projectId) {
          const rsp = await getProject(ssxms[0])
          this.projectLeader = rsp.data
          if (this.projectLeader) {
            // console.log('this.projectLeader.projectId ---------', this.projectLeader.projectId)
          }
        }
      }
      this.startProcess()
    },
    buildFlowTraceList() {
      this.data = this.flowTraceList;
    },
    getOpinionNameClass(opinions, activity) {
      let className = "agreeName"
      let pass = false
      if (activity && activity.pass) {
        pass = true
      }
      if (!pass) {
        className = "noAgreeName"
        return className
      }
      if (opinions && opinions.length > 0) {
        for (let i = 0; i < opinions.length; i++) {
          if (opinions[i].optionType === 'refuseOpinion') {
            className = "noAgreeName"
            break;
          }
        }
      }
      return className
    },
    getTrackTimeStamp(node, index, taskTracks) {
      let timeStamp = null
      if (index != taskTracks.length - 1) {
        if (node.endTime) {
          timeStamp = node.endTime
        } else {
          timeStamp = node.createTime
        }
      } else {
        if (node.endTime) {
          timeStamp = node.endTime
        }
      }
      return timeStamp
    },
    getOpinion(opinion) {
      let opinionLabel = "意见："
      if (opinion) {
        if (opinion.optionType === 'refuseOpinion') {
          opinionLabel = "退回意见："
        }
        if (opinion.optionType === 'assignOpinion') {
          opinionLabel = "转办意见："
        }
        if (opinion.optionType === 'commentOpinion') {
          opinionLabel = ""
        }
      }
      return opinionLabel + (opinion.comments ? opinion.comments : '无')
    },
    getOpinionIcon(opinions, TrackTimeStamp, index, taskTracks, activity) {
      let icon = this.image_base_url + "/duigou.png"
      let pass = false
      if (activity && activity.pass) {
        pass = true
      }
      if (!activity.createTime && !activity.endTime) {
        icon = this.image_base_url + "/diandiandian.png"
        return icon
      }
      if (!pass) {
        icon = this.image_base_url + "/cuowu.png"
        return icon
      }
      if (TrackTimeStamp) {
        icon = this.image_base_url + "/duigou.png"
        if (opinions && opinions.length > 0) {
          for (let i = 0; i < opinions.length; i++) {
            if (opinions[i].optionType === 'refuseOpinion') {
              icon = this.image_base_url + "/cuowu.png"
              break;
            }
          }
        }
      } else {
        icon = this.image_base_url + "/diandiandian.png"

      }
      return icon
    },


    // https://exerciseq.com/prod-api/profile/project/home/image/hlxx/duigou.png
    // getOpinionIcon(opinions, TrackTimeStamp, index, taskTracks, activity) {
    //   let passIcon = this.image_base_url + "/duigou.png"
    //   let pass = false
    //   if (activity && activity.pass) {
    //     pass = true
    //   }
    //   if (!pass) {
    //     icon = this.image_base_url + "/cuowu.png"
    //     return icon
    //   }
    //
    //
    //   if(!activity.createTime && !activity.endTime){
    //     icon = this.image_base_url + "/cuowu.png"
    //     return
    //   }
    //
    //   if (index != taskTracks.length - 1) {
    //     if (opinions && opinions.length > 0) {
    //       for (let i = 0; i < opinions.length; i++) {
    //         if (opinions[i].optionType === 'refuseOpinion') {
    //           icon = this.image_base_url + "/cuowu.png"
    //           break;
    //         }
    //       }
    //     } else {
    //       icon = this.image_base_url + "/duigou.png"
    //     }
    //   } else {
    //     if (TrackTimeStamp) {
    //       icon = this.image_base_url + "/duigou.png"
    //       if (opinions && opinions.length > 0) {
    //         for (let i = 0; i < opinions.length; i++) {
    //           if (opinions[i].optionType === 'refuseOpinion') {
    //             icon = this.image_base_url + "/cuowu.png"
    //             break;
    //           }
    //         }
    //       }
    //     } else {
    //       icon = this.image_base_url + "/diandiandian.png"
    //     }
    //   }
    //   return icon
    // },


    startProcess() {
      this.cc = [];
      if (!(this.runningList && this.runningList.length > 0)) {//结束，返回
        return
      }

      // console.log(this.process)
      this.getProcess(this.process, this.activities, this.cc);

      this.cc.push({
        title: "结束",
        name: "结束",
        icon: "el-icon-success",
        isEdit: false,
        pass: true
      })
      // console.log(this.taskTracks)
      // console.log('........................', this.cc)
      let curruentNodeId = this.runningList[0]
      let currentIndex = -1;
      for (let i = 0; i < this.cc.length; i++) {
        if (this.cc[i].id == curruentNodeId) {
          currentIndex = i
          break;
        }
      }
      let unDo = []
      //if(currentIndex>0){
      if (currentIndex == -1) {
        currentIndex = 0
      } else {
        let node = this.cc[currentIndex]
        if (node.mode) {
          console.log(node.mode)
          console.log(node.title)
          console.log('kkkkkkkk', node.assigneeName)
          console.log(currentIndex)
          /*if(currentIndex==0){
            //currentIndex++
          }else*/
          if (node.assigneeName) {
            if (node.assigneeName.indexOf(',') == -1) {
              currentIndex++
            } else {
              if (node.mode == 'NEXT') {
                //assigneeName = assigneeName+(assigneeNames.length)+"人依次审批"
                if (this.mergeNext(node)) {
                  currentIndex++
                }
              }
              if (node.mode == 'AND') {
                //assigneeName = assigneeName+(assigneeNames.length)+"人会签"
                currentIndex++
              }
              if (node.mode == 'OR') {
                //assigneeName = assigneeName+(assigneeNames.length)+"人或签"
                //if(this.mergeOr(node)){
                //
                // }
                currentIndex++
              }
            }
          } else {
            //无办理人跳过
            currentIndex++
          }
          //node.assigneeName.indexOf(",")
        }
      }

      if (this.actCurrentNode) {
        for (let i = 0; i < this.cc.length; i++) {
          if (this.cc[i].id == this.actCurrentNode) {
            currentIndex = i
            break;
          }
        }
      }
      unDo = this.cc.slice(currentIndex)
      //}
      this.taskTracks = this.taskTracks.concat(unDo || [])
    },
    mergeOr(node) {
      let currentIndex = -1
      for (let j = 0; j < this.taskTracks.length; j++) {
        if (!this.taskTracks[j].createTime) {
          continue;
        }
        if (!this.taskTracks[j].endTime && (this.taskTracks[j].activityId == node.id)) {
          let userNames = node.assigneeName.split(",")
          let assigneeName = node.assigneeName
          if (userNames.length > 1) {
            assigneeName = assigneeName + (userNames.length) + "人或签"
          }
          // console.log(',,,,,,,,,,,,,,,,,,,,,,,,,', assigneeName)
          this.taskTracks[j].assigneeName = assigneeName
          currentIndex = j
          break;

        }
      }
      if (currentIndex > -1) {
        for (let j = currentIndex; j < this.taskTracks.length; j++) {
          if (!this.taskTracks[j].endTime && (this.taskTracks[j].activityId == node.id)) {
            let userNames = node.assigneeName.split(",")
            let assigneeName = node.assigneeName
            if (userNames.length > 1) {
              assigneeName = assigneeName + (userNames.length) + "人或签"
            }
            // console.log(',,,,,,,,,,,,,,,,,,,,,,,,,', assigneeName)
            this.taskTracks[j].assigneeName = assigneeName
            currentIndex = j
            break;

          }
        }
        return true
      }
      return false
    },
    mergeNext(node) {
      for (let j = 0; j < this.taskTracks.length; j++) {
        if (!this.taskTracks[j].createTime) {
          continue;
        }
        if (!this.taskTracks[j].endTime && (this.taskTracks[j].activityId == node.id)) {
          let userNames = node.assigneeName.split(",")
          let assigneeName = node.assigneeName
          if (userNames.length > 1) {
            assigneeName = assigneeName + (userNames.length) + "人依次审批"
          }
          // console.log(',,,,,,,,,,,,,,,,,,,,,,,,,', assigneeName)
          this.taskTracks[j].assigneeName = assigneeName
          return true
        }
      }
      return false
    },
    getProcess(process, data, cc) {
      if (null != process && undefined != process) {
        if ('ROOT' === process.type) {
          //发起人节点
          //this.getRootNode(cc, process);
        } else if ('APPROVAL' === process.type) {
          //审批节点
          this.getApprovalNode(cc, process);
        } else if ("CC" === process.type) {
          // 抄送节点
          this.getCcNode(cc, process);
        } else if ("CONDITIONS" === process.type) {
          //判断是否符合条件符合走条件分支,否则继续递归子分支
          if (null != process.branchs && undefined != process.branchs) {
            this.getConditionNode(cc, process);
          }
        } else if ("CONCURRENTS" === process.type) {
          this.getConcurrentNode(cc, process);
        }
        if (null != process.children && undefined != process.children) {
          this.getProcess(process.children, data, cc);
        }
      }
    }
    ,
    //封装开始节点
    getRootNode(cc, process) {
      // console.log(this.endList)
      // console.log(process.id)
      if (this.endList.includes(process.id)) {
        return
      }
      cc.push({
        id: process.id,
        title: process.name,
        name: process.name || "发起人",
        icon: "el-icon-user-solid",
        isEdit: false,
        users: [this.startUser],
      })
    }
    ,
    //封装审批节点
    getApprovalNode(cc, process) {

      var data = {
        id: process.id,
        title: process.name,
        name: process.name || '审批人',
        icon: "el-icon-s-check",
        isEdit: false,
        multiple: false,
        mode: process.props.mode,
        users: [],
        desc: "",
        pass: true
      }
      // console.log(process.props.mode)
      let shouldAdd = true;
      //判断审批人类型
      switch (process.props.assignedType) {
        case "ASSIGN_USER":
          if (this.nodeUsers.hasOwnProperty(data.id)) {
            this.getApprovalUser(data)
          } else {
            this.getAssignUser(data, process.props.assignedUser);
          }
          // this.getAssignUser(data, process.props.assignedUser);
          //data.desc = "指定审批人";
          break;
        case "ASSIGN_LEADER":
          //data.desc = "指定部门的领导";
          break;
        case "SELF":
          data.assigneeName = this.startUser.name
          //data.desc = "发起人自己审批";
          break;
        case "SELF_SELECT":
          this.getApprovalUser(data)
          break;
        case "FORM_USER":
          if (process.props.formUser) {
            let users = this.formData[process.props.formUser]
            if (users && users.length > 0) {
              data.assigneeName = users[0].name
            }
          }
          break;

        case "PROJECT_MANAGER":
          //data.users = [this.loginUser]
          if (this.projectLeader && this.projectLeader.projectManagerName) {
            data.assigneeName = this.projectLeader.projectManagerName
          } else {
            data.assigneeName = "";
          }
          break;

        case "LEADER_TOP":
          //data.desc = "连续多级主管审批";
          break;
        case "LEADER":
          data.assigneeName =
              1 === process.props.leader.level
                  ? this.startUser.name + "的直接主管审批"
                  : this.startUser.name + "的第".concat(process.props.leader.level, "级主管审批");
          break;
        case "ROLE":
          data.assigneeName = "角色[".concat(
              (process.props.role || []).map(function (e) {
                return e.name;
              }),
              "]审批"
          );
          break;
        case "REFUSE":
          data.desc = "流程此处将自动驳回";
          break;
      }
      if (this.endList.includes(process.id) && (!this.runningList.includes(process.id))) {
        shouldAdd = false
      }
      if (this.runningList.includes(process.id)) {
        if (data.mode == 'NEXT') {
          shouldAdd = true
        } else {
          shouldAdd = false
        }
      }

      if (!data.assigneeName) {
        shouldAdd = false
      }

      //if(shouldAdd){
      cc.push(data);
      // }
    },
    getApprovalUser(data) {

      let assigneeName = ''
      if (this.nodeUsers.hasOwnProperty(data.id)) {
        let users = this.nodeUsers[data.id]
        // console.log(users)
        assigneeName = this.fetchUser(users, data)
        // console.log(assigneeName)
        // console.log(data)
        data.assigneeName = assigneeName
      } else {
        data.assigneeName = assigneeName
      }
    }
    ,
    getCsUser(data) {//抄送人
      let assigneeName = ''
      if (this.nodeUsers.hasOwnProperty(data.id)) {
        let users = this.nodeUsers[data.id]
        for (let i = 0; i < users.length; i++) {
          if (assigneeName == '') {
            assigneeName = users[i].name
          } else {
            assigneeName = assigneeName + "," + users[i].name
          }
        }
        data.assigneeName = assigneeName
      }
    },
    getAssignUser(data, assignedUser) {
      data.assigneeName = this.fetchUser(assignedUser, data)
    },
    fetchUser(users, data) {
      // console.log('000000000:', users)
      // console.log('111111111:', data)
      let assigneeName = ''
      if (!(users && users.length > 0)) {
        return assigneeName
      }
      let currentUsers = []
      for (let j = 0; j < this.taskTracks.length; j++) {
        if (!this.taskTracks[j].createTime) {
          continue;
        }
        if (!this.taskTracks[j].endTime && (this.taskTracks[j].activityId == data.id)) {
          currentUsers.push(this.taskTracks[j].assigneeId)
        }/*else{
            if(data.id==this.taskTracks[j].activityId){
              currentUsers.push(this.taskTracks[j].assigneeId)
            }
          }*/
      }

      // console.log(currentUsers)
      if (data.mode == 'AND') {
        //assigneeName = assigneeName+(assigneeNames.length)+"人会签"
      }
      if (data.mode == 'OR') {
        //assigneeName = assigneeName+(assigneeNames.length)+"人或签"
        for (let i = 0; i < users.length; i++) {
          if (assigneeName == '') {
            assigneeName = users[i].name
          } else {
            assigneeName = assigneeName + "," + users[i].name
          }
        }
      }
      if (data.mode == 'NEXT' || data.mode == 'AND') {
        //assigneeName = assigneeName+(assigneeNames.length)+"人依次审批"
        let currentIndex = -1;
        for (let i = 0; i < users.length; i++) {
          if (users[i].id == currentUsers[0]) {
            currentIndex = i;
            break;
          }
        }
        // console.log('yyyyyyyyy', currentIndex)
        if (currentIndex == users.length - 1) {
          assigneeName = ""
        } else {

          let reverUsers = []
          if (currentIndex == -1) {
            reverUsers = users
          } else {
            reverUsers = users.slice(currentIndex)
          }
          for (let i = 0; i < reverUsers.length; i++) {
            if (assigneeName == '') {
              assigneeName = reverUsers[i].name
            } else {
              assigneeName = assigneeName + "," + reverUsers[i].name
            }
          }
        }

      }
      return assigneeName
    },
    getCcNode(cc, process) {

      var data = {
        id: process.id,
        title: process.name,
        icon: "el-icon-s-promotion",
        name: process.name || "抄送人",
        isEdit: process.props.shouldAdd,
        type: "user",
        multiple: true,
        desc: process.props.shouldAdd ? "请选择抄送人" : "",
        users: this.$deepCopy(process.props.assignedUser),
        pass: true,
        isCs: 1
      };
      this.getCsUser(data)
      // console.log('chaosong................' + data.assigneeName)
      if (data.assigneeName && data.assigneeName != '') {
        data.isCs = 1
      } else {
        data.assigneeName = "未选择抄送人"
      }
      cc.push(data);

    }
    ,
    getConditionNode(cc, process) {
      for (var r = null, s = 0; s < process.branchs.length; s++) {
        for (var a = process.branchs[s], n = false, o = 0, i = 0; i < a.props.groups.length; i++) {
          if (a.typeElse) {
            r = a;
            break;
          }
          if (((n = this.getConditionResultByGroup(a.props.groups[i])), "OR" === a.props.groupsType && n)) {
            r = a;
            break;
          }
          "AND" === a.props.groupsType && n && o++;
        }
        if (r) {
          break;
        }
        if (o === a.props.groups.length) {
          r = a;
          break;
        }

      }
      var d = []
      r ? this.getProcess(r, d, cc)
          : console.log(
              "条件节点 "
                  .concat(process.id, " => ")
                  .concat(process.name, " 均不满足，无法继续"),
              process
          );
    }
    ,
    getConcurrentNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "并行分支",
        icon: "el-icon-s-operation",
        isEdit: false,
        active: process.branchs[0].id,
        options: [],
        desc: "切换分支可显示对应执行流程",
        branchs: {},
      }
      cc.push(data);
      process.branchs.forEach((b) => {
        data.options.push({id: b.id, title: b.name});
        this.$set(data.branchs, b.id, []);
        var d = [];
        this.getProcess(b.children, d, data.branchs[b.id])
      })

    }
    ,

    getConditionResultByGroup: function (e) {
      var t = this,
          r = !1,
          s = 0;
      e.conditions.forEach(function (e) {
        return t.conditionFormItem.add(e.id);
      });

      for (var a = 0; a < e.conditions.length; a++) {
        var n = e.conditions[a];
        switch (n.valueType) {
          case "Number":
            r = this.numberCompare(n)
            break;
          case "String":
            r = this.stringCompare(n)
            break;
          case "Date":

            break;
          case "User":
            r = this.userCompare(n)
            break;
          case "notInUser":
            r = this.notInUserCompare(n)
            break;
          case "Array":

            break;
        }
        if (r && "OR" === e.groupType) break;
        r && "AND" === e.groupType && s++;
      }
      return (
          "AND" === e.groupType && (r = s === e.conditions.length), r
      );
    }
    ,
    numberCompare: function (e) {
      var t = this.formData[e.id];
      switch (e.compare) {
        case ">":
          return t > parseFloat(e.value[0]);
        case "<":
          return t < parseFloat(e.value[0]);
        case "=":
          return t === parseFloat(e.value[0]);
        case ">=":
          return t >= parseFloat(e.value[0]);
        case "<=":
          return t <= parseFloat(e.value[0]);
        case "B":
          return (
              t > parseFloat(e.value[0]) && t < parseFloat(e.value[1])
          );
        case "AB":
          return (
              t >= parseFloat(e.value[0]) && t < parseFloat(e.value[1])
          );
        case "BA":
          return (
              t > parseFloat(e.value[0]) && t <= parseFloat(e.value[1])
          );
        case "ABA":
          return (
              t >= parseFloat(e.value[0]) && t <= parseFloat(e.value[1])
          );
        case "IN":
          return e.value.indexOf(String(t)) > -1;
        default:
          return !1;
      }
    },
    stringCompare: function (e) {
      // var t = this.formData[e.id];
      // if (t) {
      //   if (t.indexOf(",")) {
      //     t = t.split(",")[0]
      //   }
      // }
      // switch (e.compare) {
      //   case "=":
      //     return e.value[0] === String(t);
      //   case "IN":
      //     return e.value.indexOf(String(t)) > -1;
      //   default:
      //     return !1;
      // }
      var t = this.formData[e.id]
      if (t) {
        if (t.indexOf(',')) {
          t = t.split(',')[0]
        }
      }
      switch (e.compare) {
        case '=':
          return e.value[0] === String(t)
        case 'IN':
          let contains = false
          for (let i = 0; i < e.value.length; i++) {
            if (String(this.formData[e.id]).indexOf(e.value[i]) > -1) {
              contains = true
            }
          }
          return contains
        default:
          return !1
      }
    },
    userCompare: function (e) {
      // console.log('userCompare')
      // console.log(e)
      let currentUserId = parseInt(this.startUser.id)
      let currentDeptIds = this.startUser.deptIds
      // console.log("currentUserId 类型：" + typeof (currentUserId))
      // console.log("currentDeptIds 类型：" + typeof (currentDeptIds))
      // console.log("currentDeptIds 等于：" + (currentDeptIds))
      let users = e.value
      if (!users || users.length === 0) {
        return false;
      }
      let result = false
      for (let i = 0; i < users.length; i++) {
        let userObj = users[i]
        if (userObj.type === 'user') {
          if (userObj.id == currentUserId) {
            result = true
            break
          }
        }
        if (userObj.type === 'dept') {
          if (currentDeptIds.includes(userObj.id)) {
            result = true
            break
          }
        }
      }
      return result
    },
    notInUserCompare: function (e) {
      // console.log('notInUserCompare')
      // console.log(e)
      let currentUserId = parseInt(this.startUser.id)
      // console.log(typeof (currentUserId))
      let users = e.value
      if (!users || users.length === 0) {
        return true;
      }
      let conditionUserIds = []
      let result = false
      for (let i = 0; i < users.length; i++) {
        let userObj = users[i]
        conditionUserIds.push(userObj.id)
        // console.log(typeof (userObj.id))
      }
      if (!conditionUserIds.includes(currentUserId)) {
        result = true
      }
      return result
    }
  },
}
</script>

<style>
.border-left::after {
  content: '';
  width: 4px;
  background: #FFECBB;
  position: absolute;
  left: 22px;
  top: 4px;
  bottom: 4px;
}

.agreeName {
  color: #333;
}

.noAgreeName {
  color: #DA5050;
}
</style>
